// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class GoogleMap extends WebComponent {
    didMount() {
        const {
            lat,
            lng
        } = this.props;

        const position = {lat: parseFloat(lat), lng: parseFloat(lng)};

        const map = new google.maps.Map(this.element, {
            center: position,
            zoom: 15,
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false
        });

        const icon = {
            url: '/img/u/map-marker.png',
            size: new google.maps.Size(43, 54),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(21, 0)
        };

        const marker = new google.maps.Marker({position: position, icon: icon, map: map});

    }
}



// WEBPACK FOOTER //
// ./fe/web-kanken/src/js/components/GoogleMap.js